import * as types from '../constants';

const initialState = {
  loading: true,
  paymentsList: {},
  paymentsDetails: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PAYMENTS_HISTORY_START:
      return {
        loading: true,
        paymentsList: {},
      };

    case types.FETCH_PAYMENTS_HISTORY_SUCCESS:
      return {
        loading: false,
        paymentsList: action.payload,
      };

    case types.FETCH_PAYMENTS_HISTORY_FAILURE:
      return {
        loading: true,
        err: action.err,
      };

    case types.FETCH_PAYMENTS_DETAILS_START:
      return {
        loading: true,
        paymentsDetails: {},
      };

    case types.FETCH_PAYMENTS_DETAILS_SUCCESS:
      return {
        loading: false,
        paymentsDetails: action.payload,
      };

    case types.FETCH_PAYMENTS_DETAILS_FAILURE:
      return {
        loading: true,
        err: action.err,
      };

    default:
      return state;
  }
};

export default reducer;
